import { primary, secondary } from '../navigation'

export default { primary, secondary }
